module.exports = __webpack_public_path__ + "img/fire-hydrant.24468933.svg";